import type { ReactNode } from 'react';
import { PageHeader } from './Card';
import { EmptyState } from './EmptyState';
import { useBrand } from '../lib/brand';

/**
 * Wraps every `/b/:brand/...` screen. Renders the screen only when the brand in the URL is one
 * this user can read, so pages can call `useCurrentBrand()` and get a brand, never null.
 */
export function BrandRoute({ title, children }: { title: string; children: ReactNode }) {
  const { brand, loading, brands } = useBrand();
  if (loading) {
    return (
      <div className="loading" role="status">
        Loading…
      </div>
    );
  }
  if (!brand) {
    return (
      <>
        <PageHeader title={title} />
        <section className="card">
          <EmptyState title="This brand is not available" icon="lock" action={{ label: 'Go to all brands', to: '/' }}>
            {brands.length
              ? 'It may have been removed, or your account is not on its team. Pick a brand from the list in the sidebar.'
              : 'There are no brands you can see yet. The owner adds brands and team members in Settings.'}
          </EmptyState>
        </section>
      </>
    );
  }
  return <>{children}</>;
}
